// src/store/finance/financeSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFinanceSummaryByYear,
  getAnnualCategoryWiseBestSellers,
} from "../../services/financeApi"; // Make sure this is structured properly

export const fetchFinanceSummary = createAsyncThunk(
  "finance/fetchSummary",
  async (year: string, thunkAPI) => {
    const response = await getFinanceSummaryByYear(year);
    return response.data; // ✅ Only return the actual data
  }
);

export const fetchCategoryAnalysis = createAsyncThunk(
  "finance/fetchCategoryAnalysis",
  async (year: string, thunkAPI) => {
    const response = await getAnnualCategoryWiseBestSellers(year);
    return response.data; // ✅ Only return the actual data
  }
);

interface FinanceState {
  summary: any | null;
  categoryAnalysis: any[];
  loading: boolean;
  error: string | null;
}

const initialState: FinanceState = {
  summary: null,
  categoryAnalysis: [],
  loading: false,
  error: null,
};

const financeSlice = createSlice({
  name: "finance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinanceSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFinanceSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(fetchFinanceSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch finance summary";
      })
      .addCase(fetchCategoryAnalysis.fulfilled, (state, action) => {
        state.categoryAnalysis = action.payload;
      });
  },
});

export default financeSlice.reducer;
